import {gsap} from "gsap";

const toggleMobileNavAnimation = () => {
    // Element à animer
    let main_menu = document.querySelector("nav#nav-main ul")
    let menu_links = gsap.utils.toArray("li", main_menu);

    // Gsap Timeline
    let tl = gsap.timeline({ease: "power1.out", paused: true});
    tl.to('a#brand', {x: '10%', autoAlpha: 0, duration: .3})
        .to(main_menu, {x: "0%", autoAlpha: 1, duration: .3}, '-=0.3')
        .to(menu_links, {stagger: {amount: 0.35, from: "end"}, autoAlpha: 1, x: "0%", duration: .4}, '-=0.4');
    return tl;
}

export default toggleMobileNavAnimation;
